var _style, _rect, _polygon, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _line, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _rect20, _g9, _rect21, _text, _text2, _text3, _text4, _rect22, _g10, _g11, _g12, _g13, _rect23, _g14, _g15, _g16, _g17, _g18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFarHist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 290.6 237.4",
    style: {
      enableBackground: "new 0 0 290.6 237.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#57A1D8;stroke:#FFFFFF;stroke-width:0.2153;stroke-miterlimit:10;}\n\t.st1{fill:#C6C6C6;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#000000;stroke-width:0.2072;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{display:none;}\n\t.st4{display:inline;fill:none;}\n\t.st5{display:inline;fill:#4D4D4D;}\n\t.st6{font-family:'ArialMT';}\n\t.st7{font-size:3.4538px;}\n\t.st8{enable-background:new    ;}\n\t.st9{fill:#545454;}\n\t.st10{fill:none;}\n\t.st11{fill:none;stroke:#707070;stroke-width:0.4959;stroke-miterlimit:10;}\n\t.st12{fill:none;stroke:#707070;stroke-width:0.4959;stroke-miterlimit:10;stroke-dasharray:0.9892,0.9892;}\n\t.st13{font-family:'URWDIN-Regular';}\n\t.st14{font-size:8px;}\n\t.st15{fill:#409BD3;}\n\t.st16{fill:#449CD3;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.3,
    y: 160.8,
    className: "st0",
    width: 13.7,
    height: 53.2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "22,214 35.7,214 35.7,214 "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.7,
    y: 209.1,
    className: "st0",
    width: 13.7,
    height: 4.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49.4,
    y: 208.7,
    className: "st0",
    width: 13.7,
    height: 5.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 63.1,
    y: 206.8,
    className: "st0",
    width: 13.7,
    height: 7.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 76.8,
    y: 206.3,
    className: "st0",
    width: 13.7,
    height: 7.7
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 90.5,
    y: 205.3,
    className: "st0",
    width: 13.7,
    height: 8.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 104.2,
    y: 205.6,
    className: "st0",
    width: 13.7,
    height: 8.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 117.9,
    y: 202.8,
    className: "st0",
    width: 13.7,
    height: 11.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 131.5,
    y: 201.5,
    className: "st0",
    width: 13.7,
    height: 12.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 145.2,
    y: 200.4,
    className: "st0",
    width: 13.7,
    height: 13.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 158.9,
    y: 190.8,
    className: "st1",
    width: 13.7,
    height: 23.2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 172.6,
    y: 193,
    className: "st1",
    width: 13.7,
    height: 21
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 186.3,
    y: 194.1,
    className: "st1",
    width: 13.7,
    height: 19.9
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 187.6,
    className: "st1",
    width: 13.7,
    height: 26.4
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 213.7,
    y: 190.3,
    className: "st1",
    width: 13.7,
    height: 23.6
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 227.4,
    y: 191,
    className: "st1",
    width: 13.7,
    height: 23
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 241.1,
    y: 198.4,
    className: "st1",
    width: 13.7,
    height: 15.6
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 254.7,
    y: 205.2,
    className: "st1",
    width: 13.7,
    height: 8.8
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 268.4,
    y: 12.1,
    className: "st1",
    width: 13.7,
    height: 201.9
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 5,
    y1: 215.5,
    x2: 284,
    y2: 215.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.6,
    y: 213.1,
    className: "st4",
    width: 1.9,
    height: 4.1
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 8.5863 216.0318)",
    className: "st5 st6 st7"
  }, "0"), /*#__PURE__*/React.createElement("rect", {
    x: 2.8,
    y: 163.4,
    className: "st4",
    width: 7.7,
    height: 4.1
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 2.8236 166.3291)",
    className: "st5 st6 st7"
  }, "2500"), /*#__PURE__*/React.createElement("rect", {
    x: 2.8,
    y: 113.7,
    className: "st4",
    width: 7.7,
    height: 4.1
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 2.8236 116.6299)",
    className: "st5 st6 st7"
  }, "5000"), /*#__PURE__*/React.createElement("rect", {
    x: 2.8,
    y: 64,
    className: "st4",
    width: 7.7,
    height: 4.1
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 2.8236 66.9268)",
    className: "st5 st6 st7"
  }, "7500"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M37.7,222.4c0-0.9,0.1-1.5,0.4-1.9c0.4-0.5,0.8-0.7,1.6-0.7c0.8,0,1.3,0.3,1.6,0.8c0.2,0.4,0.4,0.9,0.4,1.8 v2.1c0,0.9-0.1,1.5-0.4,1.9c-0.4,0.5-0.8,0.7-1.6,0.7c-0.8,0-1.3-0.3-1.6-0.8c-0.2-0.4-0.4-0.9-0.4-1.8V222.4z M40.9,222.5 c0-1.4-0.3-2-1.2-2c-0.8,0-1.2,0.6-1.2,2v1.9c0,1.4,0.3,2,1.2,2c0.8,0,1.2-0.6,1.2-2V222.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M42.9,221.4c0-1.1,0.5-1.6,1.5-1.6c1,0,1.5,0.5,1.5,1.6v0.9c0,1.1-0.5,1.6-1.5,1.6c-1,0-1.5-0.5-1.5-1.6V221.4 z M45.2,221.5c0-0.8-0.3-1.1-0.8-1.1c-0.6,0-0.8,0.4-0.8,1.1v0.7c0,0.8,0.3,1.1,0.8,1.1c0.5,0,0.8-0.4,0.8-1.1V221.5z M47.6,219.9 h0.7l-2.2,7.1h-0.7L47.6,219.9z M47.8,224.7c0-1.1,0.5-1.6,1.5-1.6c1,0,1.5,0.5,1.5,1.6v0.9c0,1.1-0.5,1.6-1.5,1.6 c-1,0-1.5-0.5-1.5-1.6V224.7z M50.1,224.8c0-0.8-0.3-1.1-0.8-1.1s-0.8,0.4-0.8,1.1v0.7c0,0.8,0.3,1.1,0.8,1.1s0.8-0.4,0.8-1.1 V224.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M92.8,225.8l2-2.6c0.7-1,1.1-1.7,1.1-2.4c0-0.7-0.4-1-1.1-1c-0.6,0-1,0.4-1.2,1.1l-0.7-0.1 c0.1-1.1,0.8-1.7,2-1.7c1.2,0,1.8,0.6,1.8,1.8c0,0.9-0.3,1.5-1.4,2.9l-1.4,1.9h2.8v0.7h-3.9V225.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M98.9,219.2h3.2v0.7h-2.5l-0.2,2.3c0.3-0.2,0.7-0.3,1.1-0.3c0.6,0,1.2,0.3,1.5,0.7c0.3,0.3,0.4,0.8,0.4,1.6 c0,0.7-0.1,1.3-0.5,1.6c-0.4,0.4-0.9,0.6-1.7,0.6c-1.2,0-1.8-0.5-2-1.5l0.8-0.1c0.1,0.6,0.5,0.9,1.2,0.9c0.8,0,1.3-0.5,1.3-1.5 c0-1.1-0.4-1.6-1.2-1.6c-0.4,0-0.8,0.1-1.1,0.4l-0.6-0.1L98.9,219.2z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M7.8,221.7c0-1,0.2-1.6,0.6-2c0.5-0.5,1-0.7,1.9-0.7c0.9,0,1.6,0.3,2,0.9c0.3,0.4,0.5,1,0.5,1.9v1.8 c0,1-0.2,1.6-0.6,2c-0.5,0.5-1,0.7-1.9,0.7c-0.9,0-1.6-0.3-2-0.9c-0.4-0.5-0.5-1-0.5-1.9V221.7z M12,221.8c0-0.8-0.1-1.2-0.4-1.6 c-0.3-0.4-0.7-0.6-1.3-0.6c-0.6,0-1.1,0.2-1.4,0.7c-0.2,0.4-0.3,0.8-0.3,1.5v1.6c0,0.8,0.1,1.2,0.4,1.6c0.3,0.4,0.7,0.6,1.3,0.6 c0.6,0,1.1-0.2,1.4-0.7c0.2-0.4,0.3-0.8,0.3-1.5V221.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M14.2,221.1H15l1.4,4l1.4-4h0.8l-1.8,5H16L14.2,221.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M20.2,224c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4s2,0.8,2,2.4v0.4h-3.3V224z M22.8,223.2L22.8,223.2c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M25,221.1h0.6l0.1,0.5c0.3-0.4,0.6-0.6,1.2-0.6c0.3,0,0.6,0.1,1,0.3l-0.3,0.7c-0.3-0.2-0.5-0.2-0.7-0.2 c-0.7,0-1,0.6-1,2v2.4H25V221.1z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M8.1,227.6h0.8v2.5c0.4-0.3,0.8-0.5,1.4-0.5c1.3,0,1.9,0.7,1.9,2.2v0.8c0,1.5-0.6,2.2-1.9,2.2 c-0.5,0-0.9-0.1-1.2-0.3c0,0-0.1-0.1-0.3-0.2l0,0.4H8.1V227.6z M11.4,231.9c0-1.1-0.4-1.6-1.2-1.6c-0.8,0-1.2,0.5-1.2,1.5v0.8 c0,1,0.4,1.5,1.2,1.5c0.8,0,1.2-0.5,1.2-1.6V231.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M14.5,229.7v2.8c0,0.5,0,0.8,0.1,1c0.2,0.4,0.5,0.6,1,0.6c0.8,0,1.2-0.5,1.2-1.9v-2.5h0.8v5h-0.6l-0.1-0.6 c-0.3,0.4-0.7,0.6-1.4,0.6c-0.9,0-1.4-0.3-1.6-1c-0.1-0.3-0.1-0.7-0.1-1.3v-2.9H14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M19.3,227.6h0.8v1.1h-0.8V227.6z M19.3,229.7h0.8v5h-0.8V229.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M22.6,227.6v5.5c0,0.7,0.2,0.9,0.8,0.9h0.3v0.7h-0.3c-1.3,0-1.6-0.3-1.6-1.7v-5.5H22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M24.3,230.4v-0.7H25l0-1.6h0.7v1.6h1v0.7h-1v2.8c0,0.7,0.2,0.9,0.8,0.9h0.2v0.7h-0.2c-1.3,0-1.6-0.3-1.6-1.7 v-2.7H24.3z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M154.8,219.2h3.2v0.7h-2.5l-0.2,2.3c0.3-0.2,0.7-0.3,1.1-0.3c0.6,0,1.2,0.3,1.5,0.7c0.3,0.3,0.4,0.8,0.4,1.6 c0,0.7-0.1,1.3-0.5,1.6c-0.4,0.4-1,0.6-1.7,0.6c-1.2,0-1.8-0.5-2-1.5l0.8-0.1c0.1,0.6,0.5,0.9,1.2,0.9c0.8,0,1.3-0.5,1.3-1.5 c0-1.1-0.4-1.6-1.2-1.6c-0.4,0-0.8,0.1-1.1,0.4l-0.6-0.1L154.8,219.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M159.6,221.7c0-0.9,0.1-1.5,0.4-1.9c0.4-0.5,0.8-0.7,1.6-0.7c0.8,0,1.3,0.3,1.6,0.8c0.2,0.4,0.4,0.9,0.4,1.8 v2.1c0,0.9-0.1,1.5-0.4,1.9c-0.4,0.5-0.8,0.7-1.6,0.7c-0.8,0-1.3-0.3-1.6-0.8c-0.2-0.4-0.4-0.9-0.4-1.8V221.7z M162.8,221.8 c0-1.4-0.3-2-1.2-2c-0.8,0-1.2,0.6-1.2,2v1.9c0,1.4,0.3,2,1.2,2c0.8,0,1.2-0.6,1.2-2V221.8z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M213.7,219.9h-2.9v-0.7h3.8v0.5l-2.3,6.6h-0.9L213.7,219.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M216.6,219.2h3.2v0.7h-2.5l-0.2,2.3c0.3-0.2,0.7-0.3,1.1-0.3c0.6,0,1.2,0.3,1.5,0.7c0.3,0.3,0.4,0.8,0.4,1.6 c0,0.7-0.1,1.3-0.5,1.6c-0.4,0.4-0.9,0.6-1.7,0.6c-1.2,0-1.8-0.5-2-1.5l0.8-0.1c0.1,0.6,0.5,0.9,1.2,0.9c0.8,0,1.3-0.5,1.3-1.5 c0-1.1-0.4-1.6-1.2-1.6c-0.4,0-0.8,0.1-1.1,0.4l-0.6-0.1L216.6,219.2z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M266.1,220.1l-1.2,0.5l-0.3-0.7l1.7-0.8h0.6v7.1h-0.8V220.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M269.7,221.7c0-0.9,0.1-1.5,0.4-1.9c0.4-0.5,0.8-0.7,1.6-0.7c0.8,0,1.3,0.3,1.6,0.8c0.2,0.4,0.4,0.9,0.4,1.8 v2.1c0,0.9-0.1,1.5-0.4,1.9c-0.4,0.5-0.8,0.7-1.6,0.7c-0.8,0-1.3-0.3-1.6-0.8c-0.2-0.4-0.4-0.9-0.4-1.8V221.7z M272.9,221.8 c0-1.4-0.3-2-1.2-2c-0.8,0-1.2,0.6-1.2,2v1.9c0,1.4,0.3,2,1.2,2c0.8,0,1.2-0.6,1.2-2V221.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M275.1,221.7c0-0.9,0.1-1.5,0.4-1.9c0.4-0.5,0.8-0.7,1.6-0.7c0.8,0,1.3,0.3,1.6,0.8c0.2,0.4,0.4,0.9,0.4,1.8 v2.1c0,0.9-0.1,1.5-0.4,1.9c-0.4,0.5-0.8,0.7-1.6,0.7c-0.8,0-1.3-0.3-1.6-0.8c-0.2-0.4-0.4-0.9-0.4-1.8V221.7z M278.3,221.8 c0-1.4-0.3-2-1.2-2c-0.8,0-1.2,0.6-1.2,2v1.9c0,1.4,0.3,2,1.2,2c0.8,0,1.2-0.6,1.2-2V221.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M280.3,220.7c0-1.1,0.5-1.6,1.5-1.6c1,0,1.5,0.5,1.5,1.6v0.9c0,1.1-0.5,1.6-1.5,1.6c-1,0-1.5-0.5-1.5-1.6 V220.7z M282.6,220.8c0-0.8-0.3-1.1-0.8-1.1c-0.6,0-0.8,0.4-0.8,1.1v0.7c0,0.8,0.3,1.1,0.8,1.1c0.5,0,0.8-0.4,0.8-1.1V220.8z  M285,219.2h0.8l-2.2,7.1h-0.8L285,219.2z M285.2,223.9c0-1.1,0.5-1.6,1.5-1.6c1,0,1.5,0.5,1.5,1.6v0.9c0,1.1-0.5,1.6-1.5,1.6 c-1,0-1.5-0.5-1.5-1.6V223.9z M287.5,224c0-0.8-0.3-1.1-0.8-1.1c-0.6,0-0.8,0.4-0.8,1.1v0.7c0,0.8,0.3,1.1,0.8,1.1 c0.6,0,0.8-0.4,0.8-1.1V224z"
  }))), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 44.4,
    y: 118.2,
    className: "st10",
    width: 109.3,
    height: 73.4
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 159.3,
    y1: 12,
    x2: 159.3,
    y2: 12.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 159.3,
    y1: 13.5,
    x2: 159.3,
    y2: 215
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 159.3,
    y1: 215.5,
    x2: 159.3,
    y2: 216
  })))), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 105.6,
    className: "st10",
    width: 81.4,
    height: 57.9
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 30.4832 120.9073)",
    className: "st9 st13 st14"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 30.4832 130.5073)",
    className: "st9 st13 st14"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 30.4832 140.1073)",
    className: "st9 st13 st14"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 30.4832 149.7073)",
    className: "st9 st13 st14"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 63.2,
    y: 19.4,
    className: "st10",
    width: 88.5,
    height: 77.6
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M45.1,24.3l-0.5,1.6h-0.9l2.6-7.1h0.8l2.6,7.1h-0.9l-0.5-1.6H45.1z M46.7,19.8l-1.3,3.8h2.7L46.7,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M51.4,18.7v5.5c0,0.7,0.2,0.9,0.8,0.9h0.3v0.7h-0.3c-1.3,0-1.6-0.3-1.6-1.7v-5.5H51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M54.3,18.7v5.5c0,0.7,0.2,0.9,0.8,0.9h0.3v0.7h-0.3c-1.3,0-1.6-0.3-1.6-1.7v-5.5H54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M59.2,18.7v5.5c0,0.7,0.2,0.9,0.8,0.9h0.3v0.7H60c-1.3,0-1.6-0.3-1.6-1.7v-5.5H59.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M61.2,22.9c0-1.5,0.6-2.2,2.1-2.2c1.4,0,2.1,0.7,2.1,2.2v0.8c0,1.5-0.6,2.2-2.1,2.2c-1.4,0-2.1-0.7-2.1-2.2 V22.9z M64.5,23c0-1.1-0.4-1.6-1.3-1.6c-0.9,0-1.3,0.5-1.3,1.6v0.7c0,1.1,0.4,1.6,1.3,1.6c0.9,0,1.3-0.5,1.3-1.6V23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M66.5,21.5v-0.7h0.6l0-1.6h0.7v1.6h1v0.7h-1v2.8c0,0.7,0.2,0.9,0.8,0.9h0.2v0.7h-0.2c-1.3,0-1.6-0.3-1.6-1.7 v-2.7H66.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M70.6,24.8c0.4,0.4,0.7,0.5,1.3,0.5c0.8,0,1.3-0.3,1.3-0.8c0-0.3-0.1-0.5-0.3-0.6c-0.2-0.1-0.3-0.1-0.9-0.2 c-0.7-0.1-1-0.2-1.2-0.4c-0.3-0.2-0.4-0.5-0.4-1c0-1,0.6-1.5,1.7-1.5c0.8,0,1.4,0.2,1.8,0.8l-0.6,0.4c-0.3-0.4-0.6-0.5-1.2-0.5 c-0.6,0-1,0.3-1,0.8c0,0.2,0.1,0.5,0.3,0.6c0.2,0.1,0.3,0.1,0.8,0.2c0.8,0.1,1.1,0.2,1.4,0.4c0.3,0.2,0.5,0.6,0.5,1.1 c0,1-0.7,1.5-2,1.5c-0.9,0-1.6-0.3-2-0.8L70.6,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M77.1,22.9c0-1.5,0.6-2.2,2.1-2.2c1.4,0,2.1,0.7,2.1,2.2v0.8c0,1.5-0.6,2.2-2.1,2.2c-1.4,0-2.1-0.7-2.1-2.2 V22.9z M80.5,23c0-1.1-0.4-1.6-1.3-1.6c-0.9,0-1.3,0.5-1.3,1.6v0.7c0,1.1,0.4,1.6,1.3,1.6c0.9,0,1.3-0.5,1.3-1.6V23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M82.9,20.8h0.6l0.1,0.6c0.3-0.5,0.7-0.7,1.4-0.7c0.9,0,1.5,0.3,1.7,1c0.1,0.3,0.2,0.7,0.2,1.3v2.9H86V23 c0-1.2-0.3-1.6-1.1-1.6c-0.9,0-1.2,0.5-1.2,1.9v2.5h-0.8V20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M90.1,21.5v-0.7h0.6l0-1.6h0.7v1.6h1v0.7h-1v2.8c0,0.7,0.2,0.9,0.8,0.9h0.2v0.7h-0.2c-1.3,0-1.6-0.3-1.6-1.7 v-2.7H90.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M93.9,18.7h0.8v2.5c0.3-0.3,0.7-0.5,1.3-0.5c0.9,0,1.4,0.3,1.7,1c0.1,0.3,0.2,0.7,0.2,1.3v2.9H97V23 c0-1.2-0.3-1.6-1.1-1.6c-0.9,0-1.2,0.5-1.2,1.8v2.6h-0.8V18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M99.5,18.7h0.8v1.1h-0.8V18.7z M99.5,20.8h0.8v5h-0.8V20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M102.1,24.8c0.4,0.4,0.7,0.5,1.3,0.5c0.8,0,1.3-0.3,1.3-0.8c0-0.3-0.1-0.5-0.3-0.6c-0.2-0.1-0.3-0.1-0.9-0.2 c-0.7-0.1-1-0.2-1.2-0.4c-0.3-0.2-0.4-0.5-0.4-1c0-1,0.6-1.5,1.7-1.5c0.8,0,1.4,0.2,1.8,0.8l-0.6,0.4c-0.3-0.4-0.6-0.5-1.2-0.5 c-0.6,0-1,0.3-1,0.8c0,0.2,0.1,0.5,0.3,0.6c0.2,0.1,0.3,0.1,0.8,0.2c0.8,0.1,1.1,0.2,1.4,0.4c0.3,0.2,0.5,0.6,0.5,1.1 c0,1-0.7,1.5-2,1.5c-0.9,0-1.6-0.3-2-0.8L102.1,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M108.8,24.8c0.4,0.4,0.7,0.5,1.3,0.5c0.8,0,1.3-0.3,1.3-0.8c0-0.3-0.1-0.5-0.3-0.6c-0.2-0.1-0.3-0.1-0.9-0.2 c-0.7-0.1-1-0.2-1.2-0.4c-0.3-0.2-0.4-0.5-0.4-1c0-1,0.6-1.5,1.7-1.5c0.8,0,1.4,0.2,1.8,0.8l-0.6,0.4c-0.3-0.4-0.6-0.5-1.2-0.5 c-0.6,0-1,0.3-1,0.8c0,0.2,0.1,0.5,0.3,0.6c0.2,0.1,0.3,0.1,0.8,0.2c0.8,0.1,1.1,0.2,1.4,0.4c0.3,0.2,0.5,0.6,0.5,1.1 c0,1-0.7,1.5-2,1.5c-0.9,0-1.6-0.3-2-0.8L108.8,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M113.5,18.7h0.8v1.1h-0.8V18.7z M113.5,20.8h0.8v5h-0.8V20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M119.3,25.4C119.3,25.4,119.3,25.4,119.3,25.4c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2,0.2-0.7,0.3-1.3,0.3 c-1.3,0-1.9-0.7-1.9-2.2v-0.8c0-1.5,0.6-2.2,1.9-2.2c0.4,0,0.8,0.1,1.1,0.2c0,0,0.1,0.1,0.3,0.2v-2.5h0.8v7.1h-0.6L119.3,25.4z  M116.7,23.7c0,1.1,0.4,1.6,1.2,1.6c0.8,0,1.2-0.5,1.2-1.5v-0.8c0-1-0.4-1.5-1.2-1.5c-0.8,0-1.2,0.5-1.2,1.6V23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M122.4,23.7c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4c1.4,0,2,0.8,2,2.4v0.4h-3.3V23.7z M124.9,22.9L124.9,22.9c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H124.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M129,22.9c0-1.5,0.6-2.2,2.1-2.2c1.4,0,2.1,0.7,2.1,2.2v0.8c0,1.5-0.6,2.2-2.1,2.2c-1.4,0-2.1-0.7-2.1-2.2 V22.9z M132.4,23c0-1.1-0.4-1.6-1.3-1.6c-0.9,0-1.3,0.5-1.3,1.6v0.7c0,1.1,0.4,1.6,1.3,1.6c0.9,0,1.3-0.5,1.3-1.6V23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M134.3,21.5v-0.7h0.6V20c0-1,0.3-1.3,1.4-1.3h0.5v0.6h-0.3c-0.6,0-0.8,0.1-0.8,0.8v0.7h1.1v0.7h-1.1v4.4H135 v-4.4H134.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M139.6,21.5v-0.7h0.6l0-1.6h0.7v1.6h1v0.7h-1v2.8c0,0.7,0.2,0.9,0.8,0.9h0.2v0.7h-0.2c-1.3,0-1.6-0.3-1.6-1.7 v-2.7H139.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M143.4,18.7h0.8v2.5c0.3-0.3,0.7-0.5,1.3-0.5c0.9,0,1.4,0.3,1.7,1c0.1,0.3,0.2,0.7,0.2,1.3v2.9h-0.8V23 c0-1.2-0.3-1.6-1.1-1.6c-0.9,0-1.2,0.5-1.2,1.8v2.6h-0.8V18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M149.7,23.7c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4c1.4,0,2,0.8,2,2.4v0.4h-3.3V23.7z M152.2,22.9L152.2,22.9c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H152.2z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M52.6,36.2c-0.1,1.1-0.9,1.8-2.3,1.8c-0.9,0-1.5-0.3-2-0.9c-0.3-0.5-0.4-1-0.4-2v-1.5c0-1.1,0.1-1.7,0.5-2.1 c0.4-0.5,1-0.8,1.9-0.8c1.4,0,2.2,0.6,2.2,1.8l-0.8,0.1c-0.1-0.7-0.6-1.2-1.5-1.2c-1.1,0-1.6,0.6-1.6,2.3V35c0,1.6,0.4,2.3,1.6,2.3 c0.9,0,1.4-0.4,1.5-1.2L52.6,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M54.4,30.7h4.2v0.7h-3.3v2.5h2.9v0.7h-2.9v2.6h3.4v0.7h-4.2V30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M64.3,37.4c-0.4,0.4-1,0.6-1.7,0.6c-0.9,0-1.6-0.3-2-0.9c-0.3-0.5-0.5-1-0.5-1.9v-1.8c0-1,0.2-1.6,0.6-2 c0.5-0.5,1-0.7,1.9-0.7c0.9,0,1.6,0.3,2,0.9c0.3,0.4,0.5,1,0.5,1.9v1.8c0,0.8-0.1,1.3-0.3,1.7l0.8,0.7L65.1,38L64.3,37.4z M62.6,36 l0.4-0.5l1,0.8c0.2-0.4,0.2-0.6,0.2-1.2v-1.6c0-0.8-0.1-1.2-0.4-1.6c-0.3-0.4-0.7-0.6-1.3-0.6c-0.6,0-1.1,0.2-1.4,0.7 c-0.2,0.4-0.3,0.8-0.3,1.5v1.6c0,0.8,0.1,1.2,0.4,1.6c0.3,0.4,0.7,0.6,1.3,0.6c0.5,0,0.8-0.1,1.1-0.4L62.6,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M67.9,37.8h-0.8v-7.1h2.4c0.8,0,1.3,0.1,1.7,0.5c0.3,0.4,0.5,0.8,0.5,1.5c0,1.2-0.5,1.8-1.5,2l1.6,3.2h-0.9 l-1.5-3.1h-1.5V37.8z M69.5,34.1c0.9,0,1.4-0.4,1.4-1.3c0-0.9-0.5-1.3-1.5-1.3h-1.5v2.7H69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M74.9,33.5v-0.7h0.6l0-1.6h0.7v1.6h1v0.7h-1v2.8c0,0.7,0.2,0.9,0.8,0.9h0.2v0.7h-0.2c-1.3,0-1.6-0.3-1.6-1.7 v-2.7H74.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M78.7,30.7h0.8v2.5c0.3-0.3,0.7-0.5,1.3-0.5c0.9,0,1.4,0.3,1.7,1c0.1,0.3,0.2,0.7,0.2,1.3v2.9h-0.8V35 c0-1.2-0.3-1.6-1.1-1.6c-0.9,0-1.2,0.5-1.2,1.8v2.6h-0.8V30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M84.4,32.8H85l0.1,0.5c0.3-0.4,0.6-0.6,1.2-0.6c0.3,0,0.6,0.1,1,0.3l-0.3,0.7c-0.3-0.2-0.5-0.2-0.7-0.2 c-0.7,0-1,0.6-1,2v2.4h-0.8V32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M88.8,35.7c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4c1.4,0,2,0.8,2,2.4v0.4h-3.3V35.7z M91.3,34.9L91.3,34.9c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H91.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M93.8,36.8c0.4,0.4,0.7,0.5,1.3,0.5c0.8,0,1.3-0.3,1.3-0.8c0-0.3-0.1-0.5-0.3-0.6c-0.2-0.1-0.3-0.1-0.9-0.2 c-0.7-0.1-1-0.2-1.2-0.4c-0.3-0.2-0.4-0.5-0.4-1c0-1,0.6-1.5,1.7-1.5c0.8,0,1.4,0.2,1.8,0.8l-0.6,0.4c-0.3-0.4-0.6-0.5-1.2-0.5 c-0.6,0-1,0.3-1,0.8c0,0.2,0.1,0.5,0.3,0.6c0.2,0.1,0.3,0.1,0.8,0.2c0.8,0.1,1.1,0.2,1.4,0.4c0.3,0.2,0.5,0.6,0.5,1.1 c0,1-0.7,1.5-2,1.5c-0.9,0-1.6-0.3-2-0.8L93.8,36.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M98.5,30.7h0.8v2.5c0.3-0.3,0.7-0.5,1.3-0.5c0.9,0,1.4,0.3,1.7,1c0.1,0.3,0.2,0.7,0.2,1.3v2.9h-0.8V35 c0-1.2-0.3-1.6-1.1-1.6c-0.9,0-1.2,0.5-1.2,1.8v2.6h-0.8V30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M104,34.9c0-1.5,0.6-2.2,2.1-2.2c1.4,0,2.1,0.7,2.1,2.2v0.8c0,1.5-0.6,2.2-2.1,2.2c-1.4,0-2.1-0.7-2.1-2.2 V34.9z M107.3,35c0-1.1-0.4-1.6-1.3-1.6c-0.9,0-1.3,0.5-1.3,1.6v0.7c0,1.1,0.4,1.6,1.3,1.6c0.9,0,1.3-0.5,1.3-1.6V35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M110.5,30.7v5.5c0,0.7,0.2,0.9,0.8,0.9h0.3v0.7h-0.3c-1.3,0-1.6-0.3-1.6-1.7v-5.5H110.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M115.9,37.4C115.8,37.4,115.8,37.4,115.9,37.4c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2,0.2-0.7,0.3-1.3,0.3 c-1.3,0-1.9-0.7-1.9-2.2v-0.8c0-1.5,0.6-2.2,1.9-2.2c0.4,0,0.8,0.1,1.1,0.2c0,0,0.1,0.1,0.3,0.2v-2.5h0.8v7.1h-0.6L115.9,37.4z  M113.3,35.7c0,1.1,0.4,1.6,1.2,1.6c0.8,0,1.2-0.5,1.2-1.5v-0.8c0-1-0.4-1.5-1.2-1.5c-0.8,0-1.2,0.5-1.2,1.6V35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M121.1,30.7v5.5c0,0.7,0.2,0.9,0.8,0.9h0.3v0.7h-0.3c-1.3,0-1.6-0.3-1.6-1.7v-5.5H121.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M123.2,30.7h0.8v1.1h-0.8V30.7z M123.2,32.8h0.8v5h-0.8V32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M125.8,32.8h0.6l0.1,0.6c0.3-0.5,0.7-0.7,1.4-0.7c0.9,0,1.5,0.3,1.7,1c0.1,0.3,0.2,0.7,0.2,1.3v2.9h-0.8V35 c0-1.2-0.3-1.6-1.1-1.6c-0.9,0-1.2,0.5-1.2,1.9v2.5h-0.8V32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M132,35.7c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4s2,0.8,2,2.4v0.4H132V35.7z M134.6,34.9L134.6,34.9c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H134.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M138.8,30.7h0.8v2.5c0.3-0.3,0.7-0.5,1.3-0.5c0.9,0,1.4,0.3,1.7,1c0.1,0.3,0.2,0.7,0.2,1.3v2.9H142V35 c0-1.2-0.3-1.6-1.1-1.6c-0.9,0-1.2,0.5-1.2,1.8v2.6h-0.8V30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M147.2,34.5c0-0.4-0.1-0.6-0.2-0.8c-0.2-0.2-0.5-0.4-0.9-0.4c-0.5,0-0.9,0.2-1.2,0.5l-0.5-0.4 c0.4-0.5,1-0.8,1.8-0.8c0.8,0,1.3,0.2,1.6,0.7c0.2,0.3,0.2,0.6,0.2,1.2v3.2h-0.6l-0.1-0.4c-0.3,0.3-0.7,0.4-1.5,0.4 c-1.3,0-1.8-0.4-1.8-1.5c0-1.2,0.5-1.5,1.9-1.5h1.2V34.5z M146.1,35.5c-0.9,0-1.2,0.3-1.2,0.9c0,0.6,0.3,0.8,1.2,0.8 c0.5,0,0.9-0.1,1-0.3c0.1-0.1,0.1-0.3,0.1-0.7v-0.8H146.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M153,37.4C152.9,37.4,152.9,37.4,153,37.4c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2,0.2-0.7,0.3-1.3,0.3 c-1.3,0-1.9-0.7-1.9-2.2v-0.8c0-1.5,0.6-2.2,1.9-2.2c0.4,0,0.8,0.1,1.1,0.2c0,0,0.1,0.1,0.3,0.2v-2.5h0.8v7.1H153L153,37.4z  M150.4,35.7c0,1.1,0.4,1.6,1.2,1.6c0.8,0,1.2-0.5,1.2-1.5v-0.8c0-1-0.4-1.5-1.2-1.5c-0.8,0-1.2,0.5-1.2,1.6V35.7z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M31,47.7v0.8l-4.1-2.1v-0.5l4.1-2.1v0.8l-3.2,1.6L31,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M33.1,42.7h3.2v0.7h-2.5l-0.2,2.3c0.3-0.2,0.7-0.3,1.1-0.3c0.6,0,1.2,0.3,1.5,0.7c0.3,0.3,0.4,0.8,0.4,1.6 c0,0.7-0.1,1.3-0.5,1.6c-0.4,0.4-0.9,0.6-1.7,0.6c-1.2,0-1.8-0.5-2-1.5l0.8-0.1c0.1,0.6,0.5,0.9,1.2,0.9c0.8,0,1.3-0.5,1.3-1.5 c0-1.1-0.4-1.6-1.2-1.6c-0.4,0-0.8,0.1-1.1,0.4l-0.6-0.1L33.1,42.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M37.9,45.2c0-0.9,0.1-1.5,0.4-1.9c0.4-0.5,0.8-0.7,1.6-0.7c0.8,0,1.3,0.3,1.6,0.8c0.2,0.4,0.4,0.9,0.4,1.8 v2.1c0,0.9-0.1,1.5-0.4,1.9c-0.4,0.5-0.8,0.7-1.6,0.7c-0.8,0-1.3-0.3-1.6-0.8c-0.2-0.4-0.4-0.9-0.4-1.8V45.2z M41.1,45.3 c0-1.4-0.3-2-1.2-2c-0.8,0-1.2,0.6-1.2,2v1.9c0,1.4,0.3,2,1.2,2c0.8,0,1.2-0.6,1.2-2V45.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M43.1,44.2c0-1.1,0.5-1.6,1.5-1.6c1,0,1.5,0.5,1.5,1.6v0.9c0,1.1-0.5,1.6-1.5,1.6c-1,0-1.5-0.5-1.5-1.6V44.2z  M45.4,44.3c0-0.8-0.3-1.1-0.8-1.1c-0.6,0-0.8,0.4-0.8,1.1V45c0,0.8,0.3,1.1,0.8,1.1c0.5,0,0.8-0.4,0.8-1.1V44.3z M47.8,42.7h0.8 l-2.2,7.1h-0.8L47.8,42.7z M48,47.5c0-1.1,0.5-1.6,1.5-1.6c1,0,1.5,0.5,1.5,1.6v0.9c0,1.1-0.5,1.6-1.5,1.6c-1,0-1.5-0.5-1.5-1.6 V47.5z M50.4,47.5c0-0.8-0.3-1.1-0.8-1.1c-0.6,0-0.8,0.4-0.8,1.1v0.7c0,0.8,0.3,1.1,0.8,1.1c0.6,0,0.8-0.4,0.8-1.1V47.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M57.1,46.5c0-0.4-0.1-0.6-0.2-0.8c-0.2-0.2-0.5-0.4-0.9-0.4c-0.5,0-0.9,0.2-1.2,0.5l-0.5-0.4 c0.4-0.5,1-0.8,1.8-0.8c0.8,0,1.3,0.2,1.6,0.7c0.2,0.3,0.2,0.6,0.2,1.2v3.2h-0.6l-0.1-0.4c-0.3,0.3-0.7,0.4-1.5,0.4 c-1.3,0-1.8-0.4-1.8-1.5c0-1.2,0.5-1.5,1.9-1.5h1.2V46.5z M56,47.5c-0.9,0-1.2,0.3-1.2,0.9c0,0.6,0.3,0.8,1.2,0.8 c0.5,0,0.9-0.1,1-0.3c0.1-0.1,0.1-0.3,0.1-0.7v-0.8H56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M58.9,44.8h0.8l1.4,4l1.4-4h0.8l-1.8,5h-0.7L58.9,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M67.2,46.5c0-0.4-0.1-0.6-0.2-0.8c-0.2-0.2-0.5-0.4-0.9-0.4c-0.5,0-0.9,0.2-1.2,0.5l-0.5-0.4 c0.4-0.5,1-0.8,1.8-0.8c0.8,0,1.3,0.2,1.6,0.7C68,45.7,68,46,68,46.7v3.2h-0.6l-0.1-0.4c-0.3,0.3-0.7,0.4-1.5,0.4 c-1.3,0-1.8-0.4-1.8-1.5c0-1.2,0.5-1.5,1.9-1.5h1.2V46.5z M66.1,47.5c-0.9,0-1.2,0.3-1.2,0.9c0,0.6,0.3,0.8,1.2,0.8 c0.5,0,0.9-0.1,1-0.3c0.1-0.1,0.1-0.3,0.1-0.7v-0.8H66.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M69.8,42.7h0.8v1.1h-0.8V42.7z M69.8,44.8h0.8v5h-0.8V44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M73.1,42.7v5.5c0,0.7,0.2,0.9,0.8,0.9h0.3v0.7h-0.3c-1.3,0-1.6-0.3-1.6-1.7v-5.5H73.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M78,46.5c0-0.4-0.1-0.6-0.2-0.8c-0.2-0.2-0.5-0.4-0.9-0.4c-0.5,0-0.9,0.2-1.2,0.5l-0.5-0.4 c0.4-0.5,1-0.8,1.8-0.8c0.8,0,1.3,0.2,1.6,0.7c0.2,0.3,0.2,0.6,0.2,1.2v3.2h-0.6l-0.1-0.4c-0.3,0.3-0.7,0.4-1.5,0.4 c-1.3,0-1.8-0.4-1.8-1.5c0-1.2,0.5-1.5,1.9-1.5H78V46.5z M76.8,47.5c-0.9,0-1.2,0.3-1.2,0.9c0,0.6,0.3,0.8,1.2,0.8 c0.5,0,0.9-0.1,1-0.3c0.1-0.1,0.1-0.3,0.1-0.7v-0.8H76.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M80.5,42.7h0.8v2.5c0.4-0.3,0.8-0.5,1.4-0.5c1.3,0,1.9,0.7,1.9,2.2v0.8c0,1.5-0.6,2.2-1.9,2.2 c-0.5,0-0.9-0.1-1.2-0.3c0,0-0.1-0.1-0.3-0.2l-0.1,0.4h-0.6V42.7z M83.8,47c0-1.1-0.4-1.6-1.2-1.6c-0.8,0-1.2,0.5-1.2,1.5v0.8 c0,1,0.4,1.5,1.2,1.5c0.8,0,1.2-0.5,1.2-1.6V47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M86.9,42.7v5.5c0,0.7,0.2,0.9,0.8,0.9H88v0.7h-0.3c-1.3,0-1.6-0.3-1.6-1.7v-5.5H86.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M89.7,47.7c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4c1.4,0,2,0.8,2,2.4v0.4h-3.3V47.7z M92.2,46.9L92.2,46.9c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H92.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M96.6,42.7h4.1v0.7h-3.3v2.5h2.8v0.7h-2.8v3.2h-0.8V42.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M102.4,48.3l-0.5,1.6H101l2.6-7.1h0.8l2.6,7.1h-0.9l-0.5-1.6H102.4z M104,43.8l-1.3,3.8h2.7L104,43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M108.8,49.8H108v-7.1h2.4c0.8,0,1.3,0.1,1.7,0.5c0.3,0.4,0.5,0.8,0.5,1.5c0,1.2-0.5,1.8-1.5,2l1.6,3.2h-0.9 l-1.5-3.1h-1.5V49.8z M110.5,46.1c0.9,0,1.4-0.4,1.4-1.3c0-0.9-0.5-1.3-1.5-1.3h-1.5v2.7H110.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M116.3,42.7h0.8v2.5c0.4-0.3,0.8-0.5,1.4-0.5c1.3,0,1.9,0.7,1.9,2.2v0.8c0,1.5-0.6,2.2-1.9,2.2 c-0.5,0-0.9-0.1-1.2-0.3c0,0-0.1-0.1-0.3-0.2l-0.1,0.4h-0.6V42.7z M119.6,47c0-1.1-0.4-1.6-1.2-1.6c-0.8,0-1.2,0.5-1.2,1.5v0.8 c0,1,0.4,1.5,1.2,1.5c0.8,0,1.2-0.5,1.2-1.6V47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M122.7,44.8v2.8c0,0.5,0,0.8,0.1,1c0.2,0.4,0.5,0.6,1,0.6c0.8,0,1.2-0.5,1.2-1.9v-2.5h0.8v5h-0.6l-0.1-0.6 c-0.3,0.4-0.7,0.6-1.4,0.6c-0.9,0-1.4-0.3-1.6-1c-0.1-0.3-0.1-0.7-0.1-1.3v-2.9H122.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M127.1,45.5v-0.7h0.6l0-1.6h0.7v1.6h1v0.7h-1v2.8c0,0.7,0.2,0.9,0.8,0.9h0.2v0.7h-0.2c-1.3,0-1.6-0.3-1.6-1.7 v-2.7H127.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M132.3,44.8h0.8l1.1,3.9l1.3-3.9h0.5l1.3,3.9l1.1-3.9h0.8l-1.5,5h-0.7l-1.3-3.8l-1.3,3.8h-0.6L132.3,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M141.1,47.7c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4c1.4,0,2,0.8,2,2.4v0.4h-3.3V47.7z M143.6,46.9L143.6,46.9c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H143.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M145.9,44.8h0.6l0.1,0.5c0.3-0.4,0.6-0.6,1.2-0.6c0.3,0,0.6,0.1,1,0.3l-0.3,0.7c-0.3-0.2-0.5-0.2-0.7-0.2 c-0.7,0-1,0.6-1,2v2.4h-0.8V44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M150.4,47.7c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4s2,0.8,2,2.4v0.4h-3.3V47.7z M152.9,46.9L152.9,46.9c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H152.9z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M75.1,61.4C75.1,61.4,75.1,61.4,75.1,61.4c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2,0.2-0.7,0.3-1.3,0.3 c-1.3,0-1.9-0.7-1.9-2.2v-0.8c0-1.5,0.6-2.2,1.9-2.2c0.4,0,0.8,0.1,1.1,0.2c0,0,0.1,0.1,0.3,0.2v-2.5h0.8v7.1h-0.6L75.1,61.4z  M72.5,59.7c0,1.1,0.4,1.6,1.2,1.6c0.8,0,1.2-0.5,1.2-1.5v-0.8c0-1-0.4-1.5-1.2-1.5c-0.8,0-1.2,0.5-1.2,1.6V59.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M78.2,59.7c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4s2,0.8,2,2.4v0.4h-3.3V59.7z M80.7,58.9L80.7,58.9c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H80.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M82.3,56.8h0.8l1.4,4l1.4-4h0.8l-1.8,5h-0.7L82.3,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M88.4,59.7c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4c1.4,0,2,0.8,2,2.4v0.4h-3.3V59.7z M90.9,58.9L90.9,58.9c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H90.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M94,54.7v5.5c0,0.7,0.2,0.9,0.8,0.9h0.3v0.7h-0.3c-1.3,0-1.6-0.3-1.6-1.7v-5.5H94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M95.9,58.9c0-1.5,0.6-2.2,2.1-2.2c1.4,0,2.1,0.7,2.1,2.2v0.8c0,1.5-0.6,2.2-2.1,2.2c-1.4,0-2.1-0.7-2.1-2.2 V58.9z M99.3,59c0-1.1-0.4-1.6-1.3-1.6c-0.9,0-1.3,0.5-1.3,1.6v0.7c0,1.1,0.4,1.6,1.3,1.6c0.9,0,1.3-0.5,1.3-1.6V59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M101.7,56.8h0.6l0.1,0.4c0.3-0.4,0.8-0.5,1.5-0.5c1.3,0,1.9,0.7,1.9,2.2v0.8c0,1.5-0.6,2.2-1.9,2.2 c-0.6,0-1-0.1-1.4-0.5v2.6h-0.8V56.8z M104.9,59c0-1.1-0.4-1.6-1.2-1.6c-0.8,0-1.2,0.5-1.2,1.5v0.8c0,1,0.4,1.5,1.2,1.5 c0.8,0,1.2-0.5,1.2-1.6V59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M107.9,59.7c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4c1.4,0,2,0.8,2,2.4v0.4h-3.3V59.7z M110.5,58.9L110.5,58.9c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H110.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M116,61.4C115.9,61.4,115.9,61.4,116,61.4c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2,0.2-0.7,0.3-1.3,0.3 c-1.3,0-1.9-0.7-1.9-2.2v-0.8c0-1.5,0.6-2.2,1.9-2.2c0.4,0,0.8,0.1,1.1,0.2c0,0,0.1,0.1,0.3,0.2v-2.5h0.8v7.1H116L116,61.4z  M113.4,59.7c0,1.1,0.4,1.6,1.2,1.6c0.8,0,1.2-0.5,1.2-1.5v-0.8c0-1-0.4-1.5-1.2-1.5c-0.8,0-1.2,0.5-1.2,1.6V59.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M123.1,58.5c0-0.4-0.1-0.6-0.2-0.8c-0.2-0.2-0.5-0.4-0.9-0.4c-0.5,0-0.9,0.2-1.2,0.5l-0.5-0.4 c0.4-0.5,1-0.8,1.8-0.8c0.8,0,1.3,0.2,1.6,0.7c0.2,0.3,0.2,0.6,0.2,1.2v3.2h-0.6l-0.1-0.4c-0.3,0.3-0.7,0.4-1.5,0.4 c-1.3,0-1.8-0.4-1.8-1.5c0-1.2,0.5-1.5,1.9-1.5h1.2V58.5z M122,59.5c-0.9,0-1.2,0.3-1.2,0.9c0,0.6,0.3,0.8,1.2,0.8 c0.5,0,0.9-0.1,1-0.3c0.1-0.1,0.1-0.3,0.1-0.7v-0.8H122z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M125.7,56.8h0.6l0.1,0.6c0.3-0.5,0.7-0.7,1.4-0.7c0.9,0,1.5,0.3,1.7,1c0.1,0.3,0.2,0.7,0.2,1.3v2.9h-0.8V59 c0-1.2-0.3-1.6-1.1-1.6c-0.9,0-1.2,0.5-1.2,1.9v2.5h-0.8V56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M130.6,56.8h0.8l1.5,4.1l1.3-4.1h0.8l-2,5.8c-0.5,1.3-0.7,1.5-2,1.5v-0.7c0.8,0,0.9-0.1,1.2-0.9l0.2-0.7 L130.6,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M135.6,56.8h0.8l1.1,3.9l1.3-3.9h0.5l1.3,3.9l1.1-3.9h0.8l-1.5,5h-0.7l-1.3-3.8l-1.3,3.8h-0.6L135.6,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M146.6,58.5c0-0.4-0.1-0.6-0.2-0.8c-0.2-0.2-0.5-0.4-0.9-0.4c-0.5,0-0.9,0.2-1.2,0.5l-0.5-0.4 c0.4-0.5,1-0.8,1.8-0.8c0.8,0,1.3,0.2,1.6,0.7c0.2,0.3,0.2,0.6,0.2,1.2v3.2h-0.6l-0.1-0.4c-0.3,0.3-0.7,0.4-1.5,0.4 c-1.3,0-1.8-0.4-1.8-1.5c0-1.2,0.5-1.5,1.9-1.5h1.2V58.5z M145.5,59.5c-0.9,0-1.2,0.3-1.2,0.9c0,0.6,0.3,0.8,1.2,0.8 c0.5,0,0.9-0.1,1-0.3c0.1-0.1,0.1-0.3,0.1-0.7v-0.8H145.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M148.4,56.8h0.8l1.5,4.1l1.3-4.1h0.8l-2,5.8c-0.5,1.3-0.7,1.5-2,1.5v-0.7c0.8,0,0.9-0.1,1.2-0.9l0.2-0.7 L148.4,56.8z"
  }))), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7,
    y: 109,
    className: "st10",
    width: 106.4,
    height: 100.7
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M11.5,102.8c0.3,0.5,0.9,0.8,1.8,0.8c1,0,1.6-0.5,1.6-1.3c0-0.4-0.2-0.7-0.4-0.9c-0.3-0.2-0.3-0.2-1.3-0.4 c-1.5-0.4-2-0.9-2-2c0-1.2,0.8-1.9,2.2-1.9c1,0,1.7,0.3,2.1,0.9l-0.6,0.4c-0.3-0.4-0.8-0.6-1.5-0.6c-0.8,0-1.3,0.4-1.3,1.2 c0,0.7,0.4,1.1,1.6,1.4c1,0.2,1.1,0.3,1.5,0.5c0.4,0.3,0.7,0.8,0.7,1.5c0,1.3-0.9,2-2.4,2c-1.2,0-2-0.3-2.4-1L11.5,102.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M17.1,97h0.8v1.1h-0.8V97z M17.1,99.1h0.8v5h-0.8V99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M19.2,99.8v-0.7h0.6l0-1.6h0.7v1.6h1v0.7h-1v2.8c0,0.7,0.2,0.9,0.8,0.9h0.2v0.7h-0.2c-1.3,0-1.6-0.3-1.6-1.7 v-2.7H19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M23.6,102c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4s2,0.8,2,2.4v0.4h-3.3V102z M26.1,101.2L26.1,101.2c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H26.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M28.5,103.1c0.4,0.4,0.7,0.5,1.3,0.5c0.8,0,1.3-0.3,1.3-0.8c0-0.3-0.1-0.5-0.3-0.6c-0.2-0.1-0.3-0.1-0.9-0.2 c-0.7-0.1-1-0.2-1.2-0.4c-0.3-0.2-0.4-0.5-0.4-1c0-1,0.6-1.5,1.7-1.5c0.8,0,1.4,0.2,1.8,0.8l-0.6,0.4c-0.3-0.4-0.6-0.5-1.2-0.5 c-0.6,0-1,0.3-1,0.8c0,0.2,0.1,0.5,0.3,0.6c0.2,0.1,0.3,0.1,0.8,0.2c0.8,0.1,1.1,0.2,1.4,0.4c0.3,0.2,0.5,0.6,0.5,1.1 c0,1-0.7,1.5-2,1.5c-0.9,0-1.6-0.3-2-0.8L28.5,103.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M34.8,99.1h0.8l1.1,3.9l1.3-3.9h0.5l1.3,3.9l1.1-3.9h0.8l-1.5,5h-0.7l-1.3-3.8l-1.3,3.8h-0.6L34.8,99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M43.1,97h0.8v1.1h-0.8V97z M43.1,99.1h0.8v5h-0.8V99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M45.2,99.8v-0.7h0.6l0-1.6h0.7v1.6h1v0.7h-1v2.8c0,0.7,0.2,0.9,0.8,0.9h0.2v0.7h-0.2c-1.3,0-1.6-0.3-1.6-1.7 v-2.7H45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M49,97h0.8v2.5c0.3-0.3,0.7-0.5,1.3-0.5c0.9,0,1.4,0.3,1.7,1c0.1,0.3,0.2,0.7,0.2,1.3v2.9h-0.8v-2.8 c0-1.2-0.3-1.6-1.1-1.6c-0.9,0-1.2,0.5-1.2,1.8v2.6H49V97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M60.3,102.1v0.8l-4.1-2.1v-0.5l4.1-2.1v0.8l-3.2,1.6L60.3,102.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M63.8,99.5c0-0.9,0.1-1.5,0.4-1.9c0.4-0.5,0.8-0.7,1.6-0.7c0.8,0,1.3,0.3,1.6,0.8c0.2,0.4,0.4,0.9,0.4,1.8 v2.1c0,0.9-0.1,1.5-0.4,1.9c-0.4,0.5-0.8,0.7-1.6,0.7c-0.8,0-1.3-0.3-1.6-0.8c-0.2-0.4-0.4-0.9-0.4-1.8V99.5z M67,99.6 c0-1.4-0.3-2-1.2-2c-0.8,0-1.2,0.6-1.2,2v1.9c0,1.4,0.3,2,1.2,2c0.8,0,1.2-0.6,1.2-2V99.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M74.2,100.9c0-0.4-0.1-0.6-0.2-0.8c-0.2-0.2-0.5-0.4-0.9-0.4c-0.5,0-0.9,0.2-1.2,0.5l-0.5-0.4 c0.4-0.5,1-0.8,1.8-0.8c0.8,0,1.3,0.2,1.6,0.7c0.2,0.3,0.2,0.6,0.2,1.2v3.2h-0.6l-0.1-0.4c-0.3,0.3-0.7,0.4-1.5,0.4 c-1.3,0-1.8-0.4-1.8-1.5c0-1.2,0.5-1.5,1.9-1.5h1.2V100.9z M73,101.8c-0.9,0-1.2,0.3-1.2,0.9c0,0.6,0.3,0.8,1.2,0.8 c0.5,0,0.9-0.1,1-0.3c0.1-0.1,0.1-0.3,0.1-0.7v-0.8H73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M76,99.1h0.8l1.4,4l1.4-4h0.8l-1.8,5h-0.7L76,99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M84.3,100.9c0-0.4-0.1-0.6-0.2-0.8c-0.2-0.2-0.5-0.4-0.9-0.4c-0.5,0-0.9,0.2-1.2,0.5l-0.5-0.4 c0.4-0.5,1-0.8,1.8-0.8c0.8,0,1.3,0.2,1.6,0.7c0.2,0.3,0.2,0.6,0.2,1.2v3.2h-0.6l-0.1-0.4c-0.3,0.3-0.7,0.4-1.5,0.4 c-1.3,0-1.8-0.4-1.8-1.5c0-1.2,0.5-1.5,1.9-1.5h1.2V100.9z M83.2,101.8c-0.9,0-1.2,0.3-1.2,0.9c0,0.6,0.3,0.8,1.2,0.8 c0.5,0,0.9-0.1,1-0.3c0.1-0.1,0.1-0.3,0.1-0.7v-0.8H83.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M86.8,97h0.8v1.1h-0.8V97z M86.8,99.1h0.8v5h-0.8V99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M90.2,97v5.5c0,0.7,0.2,0.9,0.8,0.9h0.3v0.7H91c-1.3,0-1.6-0.3-1.6-1.7V97H90.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M95,100.9c0-0.4-0.1-0.6-0.2-0.8c-0.2-0.2-0.5-0.4-0.9-0.4c-0.5,0-0.9,0.2-1.2,0.5l-0.5-0.4 c0.4-0.5,1-0.8,1.8-0.8c0.8,0,1.3,0.2,1.6,0.7c0.2,0.3,0.2,0.6,0.2,1.2v3.2h-0.6l-0.1-0.4c-0.3,0.3-0.7,0.4-1.5,0.4 c-1.3,0-1.8-0.4-1.8-1.5c0-1.2,0.5-1.5,1.9-1.5H95V100.9z M93.9,101.8c-0.9,0-1.2,0.3-1.2,0.9c0,0.6,0.3,0.8,1.2,0.8 c0.5,0,0.9-0.1,1-0.3c0.1-0.1,0.1-0.3,0.1-0.7v-0.8H93.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M97.6,97h0.8v2.5c0.4-0.3,0.8-0.5,1.4-0.5c1.3,0,1.9,0.7,1.9,2.2v0.8c0,1.5-0.6,2.2-1.9,2.2 c-0.5,0-0.9-0.1-1.2-0.3c0,0-0.1-0.1-0.3-0.2l-0.1,0.4h-0.6V97z M100.8,101.3c0-1.1-0.4-1.6-1.2-1.6c-0.8,0-1.2,0.5-1.2,1.5v0.8 c0,1,0.4,1.5,1.2,1.5c0.8,0,1.2-0.5,1.2-1.6V101.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M104,97v5.5c0,0.7,0.2,0.9,0.8,0.9h0.3v0.7h-0.3c-1.3,0-1.6-0.3-1.6-1.7V97H104z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M106.8,102c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4c1.4,0,2,0.8,2,2.4v0.4h-3.3V102z M109.3,101.2L109.3,101.2 c0-0.5-0.1-0.8-0.3-1.1c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H109.3z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M11.4,109h4.1v0.7h-3.3v2.5H15v0.7h-2.8v3.2h-0.8V109z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M17.2,114.6l-0.5,1.6h-0.9l2.6-7.1h0.8l2.6,7.1h-0.9l-0.5-1.6H17.2z M18.7,110.1l-1.3,3.8h2.7L18.7,110.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M23.6,116.2h-0.8V109h2.4c0.8,0,1.3,0.1,1.7,0.5c0.4,0.4,0.5,0.8,0.5,1.5c0,1.2-0.5,1.8-1.5,2l1.6,3.2h-0.9 l-1.5-3.1h-1.5V116.2z M25.2,112.4c0.9,0,1.4-0.4,1.4-1.3c0-0.9-0.5-1.3-1.5-1.3h-1.5v2.7H25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M33.8,112.9c0-0.4-0.1-0.6-0.2-0.8c-0.2-0.2-0.5-0.4-0.9-0.4c-0.5,0-0.9,0.2-1.2,0.5l-0.5-0.4 c0.4-0.5,1-0.8,1.8-0.8c0.8,0,1.3,0.2,1.6,0.7c0.2,0.3,0.2,0.6,0.2,1.2v3.2h-0.6l-0.1-0.4c-0.3,0.3-0.7,0.4-1.5,0.4 c-1.3,0-1.8-0.4-1.8-1.5c0-1.2,0.5-1.5,1.9-1.5h1.2V112.9z M32.7,113.8c-0.9,0-1.2,0.3-1.2,0.9c0,0.6,0.3,0.8,1.2,0.8 c0.5,0,0.9-0.1,1-0.3c0.1-0.1,0.1-0.3,0.1-0.7v-0.8H32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M36.3,111.1h0.6l0.1,0.5c0.3-0.4,0.6-0.6,1.2-0.6c0.3,0,0.6,0.1,1,0.3l-0.3,0.7c-0.3-0.2-0.5-0.2-0.7-0.2 c-0.7,0-1,0.6-1,2v2.4h-0.8V111.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M40.8,114c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4s2,0.8,2,2.4v0.4h-3.3V114z M43.3,113.2L43.3,113.2c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H43.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M47.4,113.3c0-1.5,0.6-2.2,2.1-2.2c1.4,0,2.1,0.7,2.1,2.2v0.8c0,1.5-0.6,2.2-2.1,2.2c-1.4,0-2.1-0.7-2.1-2.2 V113.3z M50.8,113.3c0-1.1-0.4-1.6-1.3-1.6c-0.9,0-1.3,0.5-1.3,1.6v0.7c0,1.1,0.4,1.6,1.3,1.6c0.9,0,1.3-0.5,1.3-1.6V113.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M52.5,111.1h0.8l1.4,4l1.4-4h0.8l-1.8,5h-0.7L52.5,111.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M58.6,114c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4s2,0.8,2,2.4v0.4h-3.3V114z M61.1,113.2L61.1,113.2c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H61.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M63.4,111.1H64l0.1,0.5c0.3-0.4,0.6-0.6,1.2-0.6c0.3,0,0.6,0.1,1,0.3l-0.3,0.7c-0.3-0.2-0.5-0.2-0.7-0.2 c-0.7,0-1,0.6-1,2v2.4h-0.8V111.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M66.7,112.2h2.8v0.7h-2.8V112.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M71.4,109h0.8v2.5c0.4-0.3,0.8-0.5,1.4-0.5c1.3,0,1.9,0.7,1.9,2.2v0.8c0,1.5-0.6,2.2-1.9,2.2 c-0.5,0-0.9-0.1-1.2-0.3c0,0-0.1-0.1-0.3-0.2l-0.1,0.4h-0.6V109z M74.6,113.3c0-1.1-0.4-1.6-1.2-1.6c-0.8,0-1.2,0.5-1.2,1.5v0.8 c0,1,0.4,1.5,1.2,1.5c0.8,0,1.2-0.5,1.2-1.6V113.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M77.8,111.1v2.8c0,0.5,0,0.8,0.1,1c0.2,0.4,0.5,0.6,1,0.6c0.8,0,1.2-0.5,1.2-1.9v-2.5h0.8v5h-0.6l-0.1-0.6 c-0.3,0.4-0.7,0.6-1.4,0.6c-0.9,0-1.4-0.3-1.6-1C77,115,77,114.6,77,114v-2.9H77.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M82.6,109h0.8v1.1h-0.8V109z M82.6,111.1h0.8v5h-0.8V111.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M85.9,109v5.5c0,0.7,0.2,0.9,0.8,0.9H87v0.7h-0.3c-1.3,0-1.6-0.3-1.6-1.7V109H85.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M87.6,111.8v-0.7h0.6l0-1.6H89v1.6h1v0.7h-1v2.8c0,0.7,0.2,0.9,0.8,0.9H90v0.7h-0.2c-1.3,0-1.6-0.3-1.6-1.7 v-2.7H87.6z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M11.1,125.3c0-1.5,0.6-2.2,2.1-2.2c1.4,0,2.1,0.7,2.1,2.2v0.8c0,1.5-0.6,2.2-2.1,2.2c-1.4,0-2.1-0.7-2.1-2.2 V125.3z M14.4,125.3c0-1.1-0.4-1.6-1.3-1.6c-0.9,0-1.3,0.5-1.3,1.6v0.7c0,1.1,0.4,1.6,1.3,1.6c0.9,0,1.3-0.5,1.3-1.6V125.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M16.8,123.1h0.6l0.1,0.5c0.3-0.4,0.6-0.6,1.2-0.6c0.4,0,0.6,0.1,1,0.3l-0.3,0.7c-0.3-0.2-0.5-0.2-0.7-0.2 c-0.7,0-1,0.6-1,2v2.4h-0.8V123.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M22.1,123.1h0.8l1.1,3.9l1.3-3.9h0.5l1.3,3.9l1.1-3.9H29l-1.5,5h-0.6l-1.3-3.8l-1.3,3.8h-0.6L22.1,123.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M30.8,126c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4s2,0.8,2,2.4v0.4h-3.3V126z M33.4,125.2L33.4,125.2c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M35.6,123.1h0.6l0.1,0.5c0.3-0.4,0.6-0.6,1.2-0.6c0.3,0,0.6,0.1,1,0.3l-0.3,0.7c-0.3-0.2-0.5-0.2-0.7-0.2 c-0.7,0-1,0.6-1,2v2.4h-0.8V123.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M40.1,126c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4s2,0.8,2,2.4v0.4h-3.3V126z M42.6,125.2L42.6,125.2c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M50.5,127.5c-0.4,0.5-0.9,0.8-1.7,0.8c-1.3,0-2-0.8-2-2.3v-0.4c0-1.7,0.6-2.5,2-2.5c0.8,0,1.3,0.3,1.7,0.8 l-0.6,0.3c-0.3-0.4-0.5-0.5-1-0.5c-0.8,0-1.2,0.6-1.2,1.7v0.5c0,1,0.4,1.6,1.3,1.6c0.5,0,0.8-0.2,1.1-0.5L50.5,127.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M51.5,125.3c0-1.5,0.6-2.2,2.1-2.2c1.4,0,2.1,0.7,2.1,2.2v0.8c0,1.5-0.6,2.2-2.1,2.2c-1.4,0-2.1-0.7-2.1-2.2 V125.3z M54.9,125.3c0-1.1-0.4-1.6-1.3-1.6c-0.9,0-1.3,0.5-1.3,1.6v0.7c0,1.1,0.4,1.6,1.3,1.6c0.9,0,1.3-0.5,1.3-1.6V125.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M57.3,123.1h0.6l0.1,0.6c0.3-0.5,0.7-0.7,1.4-0.7c0.9,0,1.5,0.3,1.7,1c0.1,0.3,0.2,0.7,0.2,1.3v2.9h-0.8v-2.8 c0-1.2-0.3-1.6-1.1-1.6c-0.9,0-1.2,0.5-1.2,1.9v2.5h-0.8V123.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M62.9,127.1c0.4,0.4,0.7,0.5,1.3,0.5c0.8,0,1.3-0.3,1.3-0.8c0-0.3-0.1-0.5-0.3-0.6c-0.2-0.1-0.3-0.1-0.9-0.2 c-0.7-0.1-1-0.2-1.2-0.4c-0.3-0.2-0.4-0.5-0.4-1c0-1,0.6-1.5,1.7-1.5c0.8,0,1.4,0.2,1.8,0.8l-0.6,0.4c-0.3-0.4-0.6-0.5-1.2-0.5 c-0.6,0-1,0.3-1,0.8c0,0.2,0.1,0.5,0.3,0.6c0.2,0.1,0.3,0.1,0.8,0.2c0.8,0.1,1.1,0.2,1.4,0.4c0.3,0.2,0.5,0.6,0.5,1.1 c0,1-0.7,1.5-2,1.5c-0.9,0-1.6-0.3-2-0.8L62.9,127.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M67.3,123.8v-0.7h0.6l0-1.6h0.7v1.6h1v0.7h-1v2.8c0,0.7,0.2,0.9,0.8,0.9h0.2v0.7h-0.2c-1.3,0-1.6-0.3-1.6-1.7 v-2.7H67.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M71.1,123.1h0.6l0.1,0.5c0.3-0.4,0.6-0.6,1.2-0.6c0.3,0,0.6,0.1,1,0.3l-0.3,0.7c-0.3-0.2-0.5-0.2-0.7-0.2 c-0.7,0-1,0.6-1,2v2.4h-0.8V123.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M75.9,123.1v2.8c0,0.5,0,0.8,0.1,1c0.2,0.4,0.5,0.6,1,0.6c0.8,0,1.2-0.5,1.2-1.9v-2.5h0.8v5h-0.6l-0.1-0.6 c-0.3,0.4-0.7,0.6-1.4,0.6c-0.9,0-1.4-0.3-1.6-1c-0.1-0.3-0.1-0.7-0.1-1.3v-2.9H75.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M84.3,127.5c-0.4,0.5-0.9,0.8-1.7,0.8c-1.3,0-2-0.8-2-2.3v-0.4c0-1.7,0.6-2.5,2-2.5c0.8,0,1.3,0.3,1.7,0.8 l-0.6,0.3c-0.3-0.4-0.5-0.5-1-0.5c-0.8,0-1.2,0.6-1.2,1.7v0.5c0,1,0.4,1.6,1.3,1.6c0.5,0,0.8-0.2,1.1-0.5L84.3,127.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M85.3,123.8v-0.7h0.6l0-1.6h0.7v1.6h1v0.7h-1v2.8c0,0.7,0.2,0.9,0.8,0.9h0.2v0.7h-0.2c-1.3,0-1.6-0.3-1.6-1.7 v-2.7H85.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M89.7,126c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4c1.4,0,2,0.8,2,2.4v0.4h-3.3V126z M92.2,125.2L92.2,125.2c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H92.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M97.7,127.7C97.6,127.8,97.6,127.8,97.7,127.7c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2,0.2-0.7,0.3-1.3,0.3 c-1.3,0-1.9-0.7-1.9-2.2v-0.8c0-1.5,0.6-2.2,1.9-2.2c0.4,0,0.8,0.1,1.1,0.2c0,0,0.1,0.1,0.3,0.2V121h0.8v7.1h-0.6L97.7,127.7z  M95.1,126c0,1.1,0.4,1.6,1.2,1.6c0.8,0,1.2-0.5,1.2-1.5v-0.8c0-1-0.4-1.5-1.2-1.5c-0.8,0-1.2,0.5-1.2,1.6V126z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M11.3,133H12v2.5c0.4-0.3,0.8-0.5,1.4-0.5c1.3,0,1.9,0.7,1.9,2.2v0.8c0,1.5-0.6,2.2-1.9,2.2 c-0.5,0-0.9-0.1-1.2-0.3c0,0-0.1-0.1-0.3-0.2l0,0.4h-0.6V133z M14.5,137.3c0-1.1-0.4-1.6-1.2-1.6c-0.8,0-1.2,0.5-1.2,1.5v0.8 c0,1,0.4,1.5,1.2,1.5c0.8,0,1.2-0.5,1.2-1.6V137.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M17.5,138c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4s2,0.8,2,2.4v0.4h-3.3V138z M20,137.2L20,137.2c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M21.9,135.8v-0.7h0.6v-0.8c0-1,0.3-1.3,1.4-1.3h0.5v0.6h-0.3c-0.6,0-0.8,0.1-0.8,0.8v0.7h1.1v0.7h-1.1v4.4 h-0.8v-4.4H21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M25.5,137.3c0-1.5,0.6-2.2,2.1-2.2c1.4,0,2.1,0.7,2.1,2.2v0.8c0,1.5-0.6,2.2-2.1,2.2c-1.4,0-2.1-0.7-2.1-2.2 V137.3z M28.9,137.3c0-1.1-0.4-1.6-1.3-1.6c-0.9,0-1.3,0.5-1.3,1.6v0.7c0,1.1,0.4,1.6,1.3,1.6c0.9,0,1.3-0.5,1.3-1.6V137.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M31.3,135.1h0.6l0.1,0.5c0.3-0.4,0.6-0.6,1.2-0.6c0.3,0,0.6,0.1,1,0.3l-0.3,0.7c-0.3-0.2-0.5-0.2-0.7-0.2 c-0.7,0-1,0.6-1,2v2.4h-0.8V135.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M35.7,138c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4c1.4,0,2,0.8,2,2.4v0.4h-3.3V138z M38.2,137.2L38.2,137.2c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M42.7,133h4.1v0.7h-3.3v2.5h2.8v0.7h-2.8v3.2h-0.8V133z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M48.4,138.6l-0.5,1.6H47l2.6-7.1h0.8l2.6,7.1h-0.9l-0.5-1.6H48.4z M50,134.1l-1.3,3.8h2.7L50,134.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M54.9,140.2h-0.8V133h2.4c0.8,0,1.3,0.1,1.7,0.5c0.3,0.4,0.5,0.8,0.5,1.5c0,1.2-0.5,1.8-1.5,2l1.6,3.2h-0.9 l-1.5-3.1h-1.5V140.2z M56.5,136.4c0.9,0,1.4-0.4,1.4-1.3c0-0.9-0.5-1.3-1.5-1.3h-1.5v2.7H56.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M63.1,133v5.5c0,0.7,0.2,0.9,0.8,0.9h0.3v0.7h-0.3c-1.3,0-1.6-0.3-1.6-1.7V133H63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M65.3,133h0.8v1.1h-0.8V133z M65.3,135.1h0.8v5h-0.8V135.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M67.8,135.1h0.6l0.1,0.6c0.3-0.5,0.7-0.7,1.3-0.7c0.7,0,1.2,0.3,1.4,0.8c0.3-0.6,0.8-0.8,1.5-0.8 c0.9,0,1.4,0.3,1.6,1c0.1,0.3,0.1,0.7,0.1,1.3v2.9h-0.8v-2.8c0-0.5,0-0.8-0.1-1c-0.2-0.4-0.5-0.6-0.9-0.6c-0.8,0-1.1,0.5-1.1,1.8 v2.6h-0.8v-2.8c0-1.2-0.3-1.6-1-1.6c-0.8,0-1.1,0.5-1.1,1.9v2.5h-0.8V135.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M76.2,133H77v1.1h-0.8V133z M76.2,135.1H77v5h-0.8V135.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M78.3,135.8v-0.7h0.6l0-1.6h0.7v1.6h1v0.7h-1v2.8c0,0.7,0.2,0.9,0.8,0.9h0.2v0.7h-0.2c-1.3,0-1.6-0.3-1.6-1.7 v-2.7H78.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M82.4,139.1c0.4,0.4,0.7,0.5,1.3,0.5c0.8,0,1.3-0.3,1.3-0.8c0-0.3-0.1-0.5-0.3-0.6c-0.2-0.1-0.3-0.1-0.9-0.2 c-0.7-0.1-1-0.2-1.2-0.4c-0.3-0.2-0.4-0.5-0.4-1c0-1,0.6-1.5,1.7-1.5c0.8,0,1.4,0.2,1.8,0.8l-0.6,0.4c-0.3-0.4-0.6-0.5-1.2-0.5 c-0.6,0-1,0.3-1,0.8c0,0.2,0.1,0.5,0.3,0.6c0.2,0.1,0.3,0.1,0.8,0.2c0.8,0.1,1.1,0.2,1.4,0.4c0.3,0.2,0.5,0.6,0.5,1.1 c0,1-0.7,1.5-2,1.5c-0.9,0-1.6-0.3-2-0.8L82.4,139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M88.7,135.1h0.8l1.1,3.9l1.3-3.9h0.5l1.3,3.9l1.1-3.9h0.8l-1.5,5h-0.7l-1.3-3.8l-1.3,3.8h-0.6L88.7,135.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M97.4,138c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4c1.4,0,2,0.8,2,2.4v0.4h-3.3V138z M99.9,137.2L99.9,137.2c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M102.2,135.1h0.6l0.1,0.5c0.3-0.4,0.6-0.6,1.2-0.6c0.3,0,0.6,0.1,1,0.3l-0.3,0.7c-0.3-0.2-0.5-0.2-0.7-0.2 c-0.7,0-1,0.6-1,2v2.4h-0.8V135.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M106.7,138c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4s2,0.8,2,2.4v0.4h-3.3V138z M109.2,137.2L109.2,137.2c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H109.2z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M11.9,150c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4s2,0.8,2,2.4v0.4h-3.3V150z M14.4,149.2L14.4,149.2c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M16.8,151.1c0.3,0.4,0.7,0.5,1.3,0.5c0.8,0,1.3-0.3,1.3-0.8c0-0.3-0.1-0.5-0.3-0.6c-0.2-0.1-0.3-0.1-0.9-0.2 c-0.7-0.1-1-0.2-1.2-0.4c-0.3-0.2-0.4-0.5-0.4-1c0-1,0.6-1.5,1.7-1.5c0.8,0,1.4,0.2,1.8,0.8l-0.6,0.4c-0.3-0.4-0.6-0.5-1.2-0.5 c-0.6,0-1,0.3-1,0.8c0,0.2,0.1,0.5,0.3,0.6c0.2,0.1,0.3,0.1,0.8,0.2c0.8,0.1,1.1,0.2,1.4,0.4c0.3,0.2,0.4,0.6,0.4,1.1 c0,1-0.7,1.5-2,1.5c-0.9,0-1.6-0.3-2-0.8L16.8,151.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M21.2,147.8v-0.7h0.6l0-1.6h0.7v1.6h1v0.7h-1v2.8c0,0.7,0.2,0.9,0.8,0.9h0.2v0.7h-0.2c-1.3,0-1.6-0.3-1.6-1.7 v-2.7H21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M27.9,148.9c0-0.4-0.1-0.6-0.2-0.8c-0.2-0.2-0.5-0.4-0.9-0.4c-0.5,0-0.9,0.2-1.2,0.5l-0.5-0.4 c0.4-0.5,1-0.8,1.8-0.8c0.8,0,1.3,0.2,1.6,0.7c0.2,0.3,0.2,0.6,0.2,1.2v3.2h-0.6l-0.1-0.4c-0.3,0.3-0.7,0.4-1.5,0.4 c-1.3,0-1.8-0.4-1.8-1.5c0-1.2,0.5-1.5,1.9-1.5h1.2V148.9z M26.8,149.8c-0.9,0-1.2,0.3-1.2,0.9c0,0.6,0.3,0.8,1.2,0.8 c0.5,0,0.9-0.1,1-0.3c0.1-0.1,0.1-0.3,0.1-0.7v-0.8H26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M30.5,145h0.8v2.5c0.4-0.3,0.8-0.5,1.4-0.5c1.3,0,1.9,0.7,1.9,2.2v0.8c0,1.5-0.6,2.2-1.9,2.2 c-0.5,0-0.9-0.1-1.2-0.3c0,0-0.1-0.1-0.3-0.2l-0.1,0.4h-0.6V145z M33.7,149.3c0-1.1-0.4-1.6-1.2-1.6c-0.8,0-1.2,0.5-1.2,1.5v0.8 c0,1,0.4,1.5,1.2,1.5c0.8,0,1.2-0.5,1.2-1.6V149.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M36.9,145v5.5c0,0.7,0.2,0.9,0.8,0.9H38v0.7h-0.3c-1.3,0-1.6-0.3-1.6-1.7V145H36.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M39,145h0.8v1.1H39V145z M39,147.1h0.8v5H39V147.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M41.6,151.1c0.4,0.4,0.7,0.5,1.3,0.5c0.8,0,1.3-0.3,1.3-0.8c0-0.3-0.1-0.5-0.3-0.6c-0.2-0.1-0.3-0.1-0.9-0.2 c-0.7-0.1-1-0.2-1.2-0.4c-0.3-0.2-0.4-0.5-0.4-1c0-1,0.6-1.5,1.7-1.5c0.8,0,1.4,0.2,1.8,0.8l-0.6,0.4c-0.3-0.4-0.6-0.5-1.2-0.5 c-0.6,0-1,0.3-1,0.8c0,0.2,0.1,0.5,0.3,0.6c0.2,0.1,0.3,0.1,0.8,0.2c0.8,0.1,1.1,0.2,1.4,0.4c0.3,0.2,0.5,0.6,0.5,1.1 c0,1-0.7,1.5-2,1.5c-0.9,0-1.6-0.3-2-0.8L41.6,151.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M46.3,145h0.8v2.5c0.3-0.3,0.7-0.5,1.3-0.5c0.9,0,1.4,0.3,1.7,1c0.1,0.3,0.2,0.7,0.2,1.3v2.9h-0.8v-2.8 c0-1.2-0.3-1.6-1.1-1.6c-0.9,0-1.2,0.5-1.2,1.8v2.6h-0.8V145z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M52.6,150c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4c1.4,0,2,0.8,2,2.4v0.4h-3.3V150z M55.1,149.2L55.1,149.2c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H55.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M60.6,151.7C60.5,151.8,60.5,151.8,60.6,151.7c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2,0.2-0.7,0.3-1.3,0.3 c-1.3,0-1.9-0.7-1.9-2.2v-0.8c0-1.5,0.6-2.2,1.9-2.2c0.4,0,0.8,0.1,1.1,0.2c0,0,0.1,0.1,0.3,0.2V145h0.8v7.1h-0.6L60.6,151.7z  M58,150c0,1.1,0.4,1.6,1.2,1.6c0.8,0,1.2-0.5,1.2-1.5v-0.8c0-1-0.4-1.5-1.2-1.5c-0.8,0-1.2,0.5-1.2,1.6V150z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarHist);
export default __webpack_public_path__ + "static/media/far_hist.77dbf96acb52da7327c7e9a1fa144b0b.svg";
export { ForwardRef as ReactComponent };